import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const usePricingConfiguration = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "pricing_configuration" }],
    queryFn: async () => await apiClient.getPricingConfiguration(),
    select: (data) => data.results[0],
    ...options,
  });
};
